export const MIN_WIDTH = 320;
export const MIN_DESKTOP_WIDTH = 640;
export const MIN_TWO_COLUMNS_CONTAINER_WIDTH = 944;
export const MIN_WIDE_CARD_WIDTH = 459;
export const MIN_DESKTOP_CIGARETTE_WIDTH = 756;
export const MAX_WIDTH = 1100;

export const AVG_HOTELCARD_HEIGHT = 350;

export const LT_DOMAIN = 'level.travel';

export const DEFAULT_KID_AGE = 7;
